import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=34e57ae6&scoped=true&lang=pug"
import script from "./addNew.vue?vue&type=script&lang=js"
export * from "./addNew.vue?vue&type=script&lang=js"
import style0 from "./addNew.vue?vue&type=style&index=0&id=34e57ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e57ae6",
  null
  
)

export default component.exports